import type { LogRocketWorkerInitializerChannels } from '@bcf-vanilla-ts-v1-logic-worker-others/bloc/log-rocket-worker-initializer/log-rocket-worker-initializer-channels';
import type { LogRocketInitializer as VanillaLogRocketInitializer } from '@bcf-vanilla-ui-ts-v1/shared/log-rocket/log-rocket-initializer';
import { provideLogRocketInitializer as provideVanillaLogRocketInitializer } from '@bcf-vanilla-ui-ts-v1/shared/log-rocket/log-rocket-initializer';
import { releaseVersion } from '@bcf2-envs/release-version';
import { UnsubscribableWithWorkerBlocForService } from '@bcf2-v1-platforms/platform-worker/browser/unsubscribable-with-worker-bloc-for-service';
import { getAppLangSegment } from '@bcf2-v1-ui-routes/app-lang-segment';
import type { ReactiveControllerHost } from 'lit';
import { type SubscriptionLike } from 'rxjs';

export class LogRocketService extends UnsubscribableWithWorkerBlocForService<LogRocketWorkerInitializerChannels> {
  constructor(
    private _vanillaInitializer: VanillaLogRocketInitializer,
    private _productionMode: boolean,
    host: ReactiveControllerHost
  ) {
    super(host);
    this._initWorkerBloc('log-rocket-worker-initializer');
  }

  public override init(): void {
    if (!this._productionMode) {
      return;
    }
    return this._vanillaInitializer.init({
      langGetter: () => new Promise((resolve: (value: string) => void) => resolve(getAppLangSegment())),
      bloc: {
        _sub: (sub: SubscriptionLike | undefined) => (this._sub = sub),
        _subTo: (channelRx: any) => this._subTo(channelRx),
        _workerSubject: (subjectKey: any) => this._workerSubject(subjectKey)
      },
      releaseVersion
    });
  }
}

export function provideLogRocketService(host: ReactiveControllerHost): LogRocketService {
  return new LogRocketService(
    provideVanillaLogRocketInitializer(__RENDER_MODE__ === 'server'),
    __RENDER_BUILD_MODE__ === 'build-prod',
    host
  );
}
